import ActBtn from 'components/buttons/ActBtn'
import { FooterVersion } from 'components/FooterMsg'
import Screen from 'components/layout/Screen'
import { useRef } from 'react'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { getPreviousAccount } from 'state/Account'
import { isAuthenticated, login } from 'state/Auth'
import { useFieldState } from 'utils'
import './styles.scss'

export default function Login() {
	const { t }       = useTranslation()
	const dispatch    = useDispatch()
	const history     = useHistory()
	const form        = useRef()
	const prevAccount = useSelector(getPreviousAccount)

	const isAuth = useSelector(isAuthenticated)

	const [account, , accountInput] = useFieldState(prevAccount, { lowerCase: true })
	const [username, , userInput]   = useFieldState('', { lowerCase: true })
	const [password, , pwdInput]    = useFieldState('')

	const locState = useLocation().state
	const from     = locState && locState.from.pathname != '/logout'? locState.from : { pathname: '/' }

	if (isAuth) { //edge cases, but...
		goAhead()
	}

	function goAhead() {
		history.replace(from)
	}

	async function doLogin(e) {
		e.preventDefault()
		if (!form.current.reportValidity()) {
			return false
		}
		try {
			await dispatch(login({ account, username, password }))
			goAhead()
		} catch (e) {
			return false
		}
	}

	return <Screen title={t('Log in to manage your orders')} pageTitle={t('Log in')}>
		<Screen.Content addPadding>
			<Row>
				<Col xs={12} md={6}>
					<div className="login-form">
						<Form onSubmit={doLogin} ref={form}>
							<Form.Group controlId="account">
								<Form.Label>{t('Restaurant Account ID')}</Form.Label>
								<Form.Control required autoFocus autoCapitalize="none" {...accountInput}/>
							</Form.Group>

							<Form.Group controlId="username">
								<Form.Label>{t('Username')}</Form.Label>
								<Form.Control required autoCapitalize="none" autoComplete="username" {...userInput}/>
							</Form.Group>

							<Form.Group controlId="password">
								<Form.Label>{t('Password')}</Form.Label>
								<Form.Control required type="password" autoComplete="current-password" {...pwdInput}/>
							</Form.Group>

							<Form.Group>
								{/* Must be a submit btn or the form won't send on Enter; also needs an action to wrap with text state */}
								<ActBtn texts={[t('Log in'), t('Logging in'), t('Ready!')]} block variant="primary" type="submit" action={doLogin}/>
							</Form.Group>
						</Form>
					</div>
				</Col>
			</Row>

			<FooterVersion/>

		</Screen.Content>
	</Screen>
}
